import "./Home.css";
import ImageSlider from "../components/ImageSlider";
import { Link } from "react-router-dom";
import bgvideo from "../media/evening-bg.mp4";
import { Services } from "../components/Services";
import { BookSection } from "../components/BookSection";
import { PackageSection } from "../components/PackageSection";
import { ContInfo } from "../components/ContInfo";
import Typed from "typed.js";
import { useEffect, useRef } from "react";

export const Home = () => {
  const typedElement = useRef(null);

  useEffect(() => {
    const typed = new Typed(typedElement.current, {
      strings: ["Sonbhadra Tourism"],
      typeSpeed: 50, // Speed in milliseconds
      backSpeed: 30, // Speed for backspacing
      loop: true, // Set to true for looping
    });

     return () => {
      typed.destroy(); // Cleanup on component unmount
    };


  }, []);

  return (
    <>
      <div className="container">
        <section className="home" id="home">
          <div className="content">
            <h3 className="typewriter-header">
              Welcome to <span id="diff" ref={typedElement}></span>
            </h3>
            <div className="sub-head">
              {/* <p>
              The place of <span id="diff">O</span>rigin of mankind
              </p> */}
              <Link className="btn" to="/locations">
                <button className="exp-btn">Explore</button>
              </Link>
            </div>
          </div>

          <div className="video-container">
            <video src={bgvideo} id="video-slider" loop autoPlay muted></video>
          </div>

          <div className="info">
            <div className="mail">
              <i className="fas fa-envelope" id="ficons"></i>
              <p>
                <a href="mailto:contact@sonbhadratourism.com">
                contact@sonbhadratourism.com
                </a>
              </p>
            </div>
            <div className="socialm">
            <a href="https://www.instagram.com/sonebhadratourism" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-instagram" id="ficons"></i>
              <p>Sonbhadratourism</p>
              </a>
            </div>
            <div className="call">
              <i className="fas fa-phone-alt" id="ficons"></i>
              <p>
                <a href="tel:6394712952">+91-9415930411</a>
              </p>
            </div>
          </div>
        </section>
      </div>
       {/* Add Image Slider */}
       <ImageSlider />

      <BookSection />
      <PackageSection />
      <hr id="line" />
      <Services />
      <hr id="line" />
      <ContInfo />
      <hr id="line" />
    </>
  );
};
